export const USER_ROLES = [
  { value: 'ADMIN', label: '관리자' },
  { value: 'USER', label: '일반' },
];

export const getRoleLabel = (role) => {
  const found = USER_ROLES.find((item) => item.value === role);
  return found ? found.label : role;
};
